// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverSnoozeRequest {
	seconds: number;

	relay: number;

	$type?: string | undefined;
}
export class DriverSnoozeRequest {
	constructor(data?: IDriverSnoozeRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	seconds: number = 0;

	relay: number = 0;

	static $type: string = "CoreApi.Models.DriverSnoozeRequest, ";
	$type?: string | undefined = DriverSnoozeRequest.$type;
}

